// ** React Imports
import { Ref, useState, forwardRef, ReactElement, useEffect } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Typography,
    Dialog,
    DialogContent,
    DialogActions
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../components/icon';
import apiUrl from '../../configs/constant';
import MsiDatagrid from '../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import Fade, { FadeProps } from '@mui/material/Fade'
import { BoxProps } from '@mui/material/Box'
import { styled } from '@mui/material/styles'


const Transition = forwardRef(function Transition(
    props: FadeProps & { children?: ReactElement<any, any> },
    ref: Ref<unknown>
) {
    return <Fade ref={ref} {...props} />
})

const BoxWrapper = styled(Box)<BoxProps>(({ theme }) => ({
    position: 'relative',
    padding: theme.spacing(12, 6, 6),
    borderRadius: theme.shape.borderRadius
}))


export default function DialogOtorisasi(data: any) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    // ** State
    const [show, setShow] = useState<boolean>(false)
    const [password, setPassword] = useState<string>('')
    const [keterangan, setKeterangan] = useState<string>('')
    const [oto, setOto] = useState<string>('')
    const [passwordError, setPasswordError] = useState<boolean>(false)
    const [keteranganError, setKeteranganError] = useState<boolean>(false)
    const [cardoto, setCardoto] = useState<any[]>([])
    const [sOto, setSOto] = useState<string>('')
    const [otMax, setOtMax] = useState<any>(null)

    const otorisasiDocument = () => {
        let save = true
        if (password == '' || password == null) {
            setPasswordError(true)
            save = false
        }
        if (sOto != 'Otorisasi') {
            if (keterangan == '' || keterangan == null) {
                setKeteranganError(true)
                save = false
            }
        }

        if (!save) {
            return null
        }
        setShow(false)

        let formdata = data
        formdata.password = password
        formdata.keterangan = keterangan
        formdata.oto = oto

        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/system/dokumen/otorisasi'
        axios
            .post(url, formdata, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        html: response.data.message,
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: true,
                        willClose: () => {
                            window.location.reload()
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        html: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    const getDetailOtorisasi = () => {
        const url = apiUrl.apiUrl + '/system/dokumen/info-otorisasi-dokumen'
        axios
            .get(url, { params: { id: data.id, tabel: data.tabel }, headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    const resp = response.data.data
                    let respdata = []
                    setOtMax(resp[0].ot_max)
                    for (let index = 0; index < resp[0].ot_max; index++) {
                        const element: any = {} as any
                        element.key = index + 1
                        element.display = 'Otorisasi ' + (index + 1)
                        element.oto = ''
                        element.ot_max = resp[0].ot_max
                        element.tingkat_otorisasi = resp[0].tingkat_otorisasi
                        element.bisa_oto = false
                        element.bisa_batal_oto = false
                        element.sudah_teroto = false

                        switch (index) {
                            case 0:
                                element.oto = resp[0].ot1
                                if (resp[0].ot2 != '' && resp[0].ot2 != null && !resp[0].ot2.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else if (resp[0].ot3 != '' && resp[0].ot3 != null && !resp[0].ot3.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else if (resp[0].ot4 != '' && resp[0].ot4 != null && !resp[0].ot4.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else if (resp[0].ot5 != '' && resp[0].ot5 != null && !resp[0].ot5.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else {
                                    if (resp[0].ot1 != '' && resp[0].ot1 != null && !resp[0].ot1.includes('(BATAL)')) {
                                        element.bisa_batal_oto = true
                                    } else {
                                        element.bisa_oto = true
                                    }
                                }

                                break
                            case 1:
                                element.oto = resp[0].ot2
                                if (resp[0].ot3 != '' && resp[0].ot3 != null && !resp[0].ot3.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else if (resp[0].ot4 != '' && resp[0].ot4 != null && !resp[0].ot4.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else if (resp[0].ot5 != '' && resp[0].ot5 != null && !resp[0].ot5.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else {
                                    if (resp[0].ot2 != '' && resp[0].ot2 != null && !resp[0].ot2.includes('(BATAL)')) {
                                        element.bisa_batal_oto = true
                                    } else {
                                        element.bisa_oto = true
                                    }
                                }
                                break
                            case 2:
                                element.oto = resp[0].ot3
                                if (resp[0].ot4 != '' && resp[0].ot4 != null && !resp[0].ot4.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else if (resp[0].ot5 != '' && resp[0].ot5 != null && !resp[0].ot5.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else {
                                    if (resp[0].ot3 != '' && resp[0].ot3 != null && !resp[0].ot3.includes('(BATAL)')) {
                                        element.bisa_batal_oto = true
                                    } else {
                                        element.bisa_oto = true
                                    }
                                }
                                break
                            case 3:
                                element.oto = resp[0].ot4
                                if (resp[0].ot5 != '' && resp[0].ot5 != null && !resp[0].ot5.includes('(BATAL)')) {
                                    element.sudah_teroto = true
                                } else {
                                    if (resp[0].ot4 != '' && resp[0].ot4 != null && !resp[0].ot4.includes('(BATAL)')) {
                                        element.bisa_batal_oto = true
                                    } else {
                                        element.bisa_oto = true
                                    }
                                }
                                break
                            case 4:
                                element.oto = resp[0].ot5

                                if (resp[0].ot5 != '' && resp[0].ot5 != null && !resp[0].ot1.includes('(BATAL)')) {
                                    element.bisa_batal_oto = true
                                } else {
                                    element.bisa_oto = true
                                }
                                break
                            default:
                                break
                        }

                        respdata.push(element)
                    }
                    setCardoto(respdata)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        html: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    useEffect(() => {
        getDetailOtorisasi()
    }, [])

    return (
        <Box>
            <Box sx={{ mb: 4, textAlign: 'center' }}>
                <Divider sx={{ m: 0 }} />
                <Typography variant='body1' sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    OTORISASI DOKUMEN
                </Typography>
                <Divider sx={{ m: 0 }} />
            </Box>
            <Grid container spacing={6} sx={{ justifyContent: 'center' }}>
                {otMax <= 5 ? (
                    cardoto.map(card => {
                        const isDisabled = card.key > card.tingkat_otorisasi
                        return (
                            <Grid item xs={12} md={3} key={card.key}>
                                <BoxWrapper
                                    sx={{
                                        border: theme => `3px solid ${theme.palette.success.main}`
                                    }}
                                >
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography variant='h5' sx={{ mb: 1.5 }}>
                                            {card.display}
                                        </Typography>

                                        {card.oto == '' ? (
                                            <Typography sx={{ marginTop: 8 }} variant='subtitle1'>
                                                {card.oto}
                                            </Typography>
                                        ) : (
                                            <Typography variant='subtitle1'>{card.oto}&nbsp;</Typography>
                                        )}
                                        <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center' }}>
                                            {card.bisa_oto ? (
                                                <Button
                                                    disabled={isDisabled}
                                                    onClick={() => {
                                                        setSOto('Otorisasi')
                                                        setShow(true)
                                                        setOto(card.key)
                                                        setPassword('')
                                                        setKeterangan('')
                                                    }}
                                                    sx={{ mt: 3 }}
                                                    variant='contained'
                                                >
                                                    Otorisasi
                                                </Button>
                                            ) : card.bisa_batal_oto ? (
                                                <>
                                                    {isDisabled ? (<Button color={'success'} sx={{ mt: 3 }} variant='contained'>
                                                        <Icon icon='mdi:check' />
                                                        Sudah Otorisasi
                                                    </Button>) : (

                                                        <Button
                                                            color={'error'}
                                                            onClick={() => {
                                                                setSOto('Batal Otorisasi')
                                                                setShow(true)
                                                                setOto(card.key)
                                                                setPassword('')
                                                                setKeterangan('')
                                                            }}
                                                            sx={{ mt: 3 }}
                                                            variant='contained'
                                                        >
                                                            <Icon icon='mdi:close' />
                                                            Batal Otorisasi
                                                        </Button>
                                                    )
                                                    }
                                                </>
                                            ) : card.sudah_teroto ? (
                                                <Button color={'success'} sx={{ mt: 3 }} variant='contained'>
                                                    <Icon icon='mdi:check' />
                                                    Sudah Otorisasi
                                                </Button>
                                            ) : (
                                                <Button color={'error'} sx={{ mt: 3 }} variant='contained'>
                                                    <Icon icon='mdi:close' />
                                                    Belum Otorisasi
                                                </Button>
                                            )}
                                        </Box>
                                    </Box>
                                </BoxWrapper>
                            </Grid>
                        )
                    })
                ) : (
                    <Typography
                        variant='body1'
                        sx={{ marginTop: 10, marginBottom: 10, textAlign: 'center', fontWeight: 'bold', color: 'red' }}
                    >
                        OTORISASI MENGGUNAKAN ERP
                    </Typography>
                )}
            </Grid>
            <Dialog
                fullWidth
                open={show}
                scroll='body'
                maxWidth='sm'
                onClose={() => setShow(false)}
                TransitionComponent={Transition}
            >
                <DialogContent sx={{ px: { xs: 8, sm: 15 }, py: { xs: 8, sm: 12.5 }, position: 'relative', color: '#212121' }}>
                    <Box sx={{ mb: 8, textAlign: 'center' }}>
                        <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                            {sOto} {data.menu}
                        </Typography>
                    </Box>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type='password'
                                value={password}
                                error={passwordError}
                                helperText={passwordError ? 'Form masih kosong.' : ''}
                                required
                                onChange={e => {
                                    setPassword(e.target.value)
                                    if (e.target.value != null && e.target.value != '') {
                                        setPasswordError(false)
                                    }
                                }}
                                label='Password Anda'
                                placeholder='Masukkan Password Anda'
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                required={sOto == 'Otorisasi' ? false : true}
                                label='Keterangan'
                                value={keterangan}
                                error={keteranganError}
                                helperText={keteranganError ? 'Form masih kosong.' : ''}
                                onChange={e => {
                                    setKeterangan(e.target.value)
                                    if (e.target.value != null && e.target.value != '') {
                                        setKeteranganError(false)
                                    }
                                }}
                                placeholder='Masukkan Keterangan'
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ pb: { xs: 8, sm: 12.5 }, justifyContent: 'center' }}>
                    <Button variant='contained' sx={{ mr: 2 }} onClick={() => otorisasiDocument()}>
                        {sOto}
                    </Button>
                    <Button variant='outlined' color='primary' onClick={() => setShow(false)}>
                        Batal
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}
